/* ==========================================================================
   Hero Banner Section — vanilla JS
   Handles optional fade-in-on-load animation via IntersectionObserver.
   ========================================================================== */

(function () {
  'use strict';

  function initHero(hero) {
    var enableAnimation = hero.dataset.enableAnimation === 'true';
    if (!enableAnimation) return;

    hero.classList.add('hero--animate');

    if (!('IntersectionObserver' in window)) {
      hero.classList.add('hero--in-view');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            hero.classList.add('hero--in-view');
            observer.unobserve(hero);
          }
        });
      },
      { threshold: 0.15 }
    );

    observer.observe(hero);
  }

  function initAll() {
    document.querySelectorAll('[data-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var hero = event.target.querySelector('[data-hero]');
    if (hero) initHero(hero);
  });
})();